<template>
    <div>
    <section class="container-fluid p-0 bodyArea">
        <div class="containerBox">
        <div class="pageHeader row m-0 align-items-center" v-if="$auth.isAuthenticated">
          <div class="col-3 pageHeaderTitle">Caching</div>
        </div>
        <div class="col text-right tfilters p-0">
                <input v-model="filterSearchString" type="text" maxlength="20" class="filterInputText " placeholder="Enter atleast 3 characters"/>
        <div>
              </div>
            </div>
      </div>
      <div
          class="pageDataWrapper pageActualDataWrapper"
      >

      <div class="contentHeader row m-0 align-items-center">
          <div class="col">
            Cache keys
          </div>
          <div class="col-1">
            Actions
          </div>
        </div>
      <div v-if="list.length > 0" class="contentDataWrap">
          <div v-for="item in filterdList" v-bind:key="item.id">
            <div
                class="
                contentDataWrapper
                actions
                contentActualDataWrapper
                row
                m-0
              "
            >
              <div
                  class="contentData row m-0 align-items-center col-12 p-0"
              >
                <div class="col">{{ item }}</div>
                <div 
                class="col-1" @click="deleteCacheKey(item)">
                <img
                    src="../assets/images/delete.svg"
                    width="16"
                    style="margin-left:8px"
                />
            </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    </section>
    </div>
  </template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vue from "vue";
import VueToast from "vue-toast-notification";

Vue.use(VueToast);
Vue.use(Loading);
export default{
  name: "Caching",
    data() {
        return {
        list: [],
        filterSearchString:""
    }
    },
    mounted() {
    this.fetchData();
  },
  computed:{
    filterdList(){
      if(this.filterSearchString.length<3){
        return this.list
      }
      else{
        return this.list.filter((item) =>
        item.toLowerCase().includes(this.filterSearchString.toLowerCase())
      );
      }
    }
  },
methods: {
  async fetchData() {
    let loader = Vue.$loading.show({
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.list = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      if (this.dateValue == "") {
        this.dateValue = new Date().toISOString().split('T')[0];
      }
      var Url = config.TENET_SERVICE + `/cache-keys`;
      try {
        const res = await fetch(Url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        if (res.status == 503) {
        return this.fetchData();
      } else {
        const newRes = await res.json();
        this.list = newRes.allKeys;
        loader.hide();
      }
      } catch (err) {
        loader.hide();
        console.log(err);
      }
    },
    async deleteCacheKey(key) {
      let loader = Vue.$loading.show({
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var locUrl =
        config.TENET_SERVICE +
        `/cache-keys/${key}`;
      var deleteKeyRequest = new Request(locUrl, {
        method: "DELETE",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var newUserResponse = await fetch(deleteKeyRequest);
        if (newUserResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          return;
        }
        if (newUserResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          return;
        }
        if (newUserResponse.status === 503) {
          this.errorMessage = "TRY AGAIN!";
        }
        if (newUserResponse.status != 200) {
          this.errorMessage = "Failed to delete key";
        } else {
        loader.hide();
          Vue.$toast.open({
            message: `Successfully Deleted Cache Key ${key}`,
            type: "success",
          });
          this.fetchData();
        }
      } catch (tex) {
        loader.hide();
        return { error: `Failed to delete cache key ${key}` };
      }
    },
}
}
</script>
<style lang="scss" scoped>
@import "../style.scss";
.tfilters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}
.pageHeader {
  font-family: GTWalsheimPro-Regular !important;
  font-size: 15px;
  font-weight: 400;
}

.pageActualDataWrapper {
  max-height: 100%;
}

.contentDataWrapper {
  font-family: GTWalsheimPro-Regular !important;

  font-size: 16px;
  //overflow-y: auto;
  overflow-x: hidden;
  font-weight: 400;
}

.contentDataWrapper.actions {
  overflow: initial !important;
}

.contentDataWrapper.actions .contentData > div.dropdownAction {
  overflow: initial !important;
}

.contentDataWrap {
  // max-height: calc( 100vh - 160px );;
  //max-height: calc( 100vh - 100px );
  height: 100%;
  overflow-y: auto;
  padding-bottom: 20px;
}
.filterInputText{
  max-width: 285px !important;
  position:relative;
  top:3px;
  right:15px
}

.flex-10 {
  flex: 10 !important;
}

.contentHeader {
  font-family: GTWalsheimPro-Regular !important;
  font-size: 16px;
  overflow-x: hidden;
  font-weight: 400;
}

.filterWrapper {
  background: #1dd8f6;
  display: inline-flex;
  font-size: 16px;
  min-width: 250px;
  border-radius: 5px;
  margin-left: 15px;
  //max-width: 250px;
  line-height: 40px;
  text-overflow: ellipsis;
}

.dropdown {
  cursor: pointer;
  background: transparent !important;
  border: 0px;
}

.filterText {
  color: #fff;
  opacity: 0.4;
  padding-right: 20px;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.actionBtn.clientShowBtn.btn-secondary {
  border-radius: 5px;
  min-width: 80px;
  text-align: center !important;
  display: inline-grid;
  background: #00b5da;
  color: #fff;
  line-height: 40px;
  padding: 0 15px;
  cursor: pointer;
  font-size: 16px;
  border-color: #00b5da;
}

.actionBtn.clientShowBtn.btn-secondary:hover {
  background: #1dd8f6;
  color: #ffffff;
  border-color: #1dd8f6;
}

.col:first-child {
  border-right: 1px solid #c7c7c7;
  padding-right: 20px;
}

textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

.text-right {
  text-align: left !important;
}
.pageHeaderTitle {
  padding-left: 0px !important;
}
</style>
